const MOBILE_ITEMS_PER_PAGE = 2.5;
const TABLET_ITEMS_PER_PAGE = 4;
const DESKTOP_ITEMS_PER_PAGE = 6;

const TRACKING_VARIANT_BROWSE = 'browse';
const TRACKING_VARIANT_PDP = 'pdp';
const TRACKING_PERSONALIZED_TYPE_TRENDING = 'trending';
const TRACKING_PERSONALIZED_TYPE_PERSONALIZATION = 'personalization';

export {
    MOBILE_ITEMS_PER_PAGE,
    TABLET_ITEMS_PER_PAGE,
    DESKTOP_ITEMS_PER_PAGE,
    TRACKING_VARIANT_BROWSE,
    TRACKING_VARIANT_PDP,
    TRACKING_PERSONALIZED_TYPE_TRENDING,
    TRACKING_PERSONALIZED_TYPE_PERSONALIZATION,
};
